import { Routes, Route } from "react-router-dom";
import FocusDenLanding from "./pages/FocusDenLanding";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutFounder from "./pages/AboutFounder";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<FocusDenLanding />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/about" element={<AboutFounder />} />
      {/* <Route path="/terms" element={<Terms />} /> */}
        {/* IMPORTANT */}
  <Route path="/sitemap.xml" element={null} />
    </Routes>
  );
}
